export default "__VITE_ASSET__DWd0TfzK__"